import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { GET_ALL_PSP_SERVICES_API } from '../../constants/central-api';
import { setAvailablePSP } from '../../../store/reducers/userSlice';

export default async function get_all_psp_api_call() {
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${GET_ALL_PSP_SERVICES_API}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_AVAILABLE_PSP_DATA';
  const customMsg = 'Available PSP Data Loaded Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response?.success) {
    return [];
  }
  if (res?.actionType === actionType && response?.success === true) {
    if (response.data === null) {
      return [];
    } else {
      store.dispatch(setAvailablePSP(response?.data));
      return response?.data;
    }
  }
}
